import { createContext } from "react";

export const LoyaltyLayoutContext = createContext();

const LoyaltyLayoutProvider = ({ children, value }) => {
  return (
    <LoyaltyLayoutContext.Provider value={value}>
      {children}
    </LoyaltyLayoutContext.Provider>
  );
};

export default LoyaltyLayoutProvider;
